import { removeCpfFormatting } from "utils/formatters";

 export  const sellerUpdateFactory = (sellerData, sellerBankAccountFeatureEnabled: boolean) => {
  
  const basePayload = {
    name: sellerData.name,
    code: removeCpfFormatting(sellerData.code),
    storeId: sellerData.storeId,
  };

  const bankAccountPayload = sellerBankAccountFeatureEnabled ? {
    role: sellerData.role,
    email: sellerData.email,
    phoneAreaCode: sellerData.phoneAreaCode,
    phoneNumber: sellerData.phoneNumber,
    pixKey: sellerData.pixKey,
  } : {};

  return {
    ...basePayload,
    ...bankAccountPayload
  };
};